export async function fetchSlots(apiBaseUrl, tenantSlug, period = {}, publishableKey = null) {
  const url = new URL(`${apiBaseUrl}/api/v1/${tenantSlug}/slots`);

  if (period.from && period.to) {
    url.searchParams.set("from", period.from);
    url.searchParams.set("to", period.to);
  }

  const response = await fetch(url, {
    headers: buildHeaders(publishableKey)
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw payload;
  }

  // L'API renvoie la timezone du tenant + le comportement du formulaire
  // (source de vérité) à côté des créneaux.
  return {
    slots: payload.slots || [],
    timezone: payload.timezone || null,
    form: payload.form || null
  };
}

export async function bookSlot(apiBaseUrl, tenantSlug, request, publishableKey = null) {
  const response = await fetch(`${apiBaseUrl}/api/v1/${tenantSlug}/book`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...buildHeaders(publishableKey) },
    body: JSON.stringify(request)
  });
  const payload = await response.json().catch(() => ({}));

  // Contrat v1 : succès = 2xx (201 Created), erreurs = {success:false, code, message}
  if (!response.ok) {
    throw payload;
  }

  return payload;
}

function buildHeaders(publishableKey) {
  return publishableKey ? { "X-Publishable-Key": publishableKey } : {};
}
